import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Paragraph from '../../Paragraph/Paragraph';
import Modal from '../../Modal';
import ButtonPrimary from '../../Buttons/Button';
import themeColors from '../../../assets/styles/themeColors';

const CameraAccessModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      variant="md"
      isOpen={isOpen}
      onClose={onClose}
      label={t('cameraAccess.title')}
    >
      <Paragraph color={themeColors.colorTextXLLight} mb={14}>
        {t('cameraAccess.cta1')}
      </Paragraph>
      <Paragraph color={themeColors.colorTextXLLight} mb={28}>
        {t('cameraAccess.cta2')}
      </Paragraph>
      <ButtonPrimary onClick={onClose} title={t('common.ok')} />
    </Modal>
  );
};

CameraAccessModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default CameraAccessModal;
